/**
 * Share of trip value directed to the GreenPak Fund. One number so tour pages,
 * the homepage badge, cart line items, and partner stats cannot drift.
 */
export const GREENPAK_FUND_PERCENT = 2;
